import { toast } from "react-toastify";
import { useApi } from "../../../../hooks/useApi";
import Flex from "../../../DefaultStyles/Flex";
import Loader from "../../../DefaultStyles/Loader";
import DefaultModalLayout, {
  ModalFixedBox,
} from "../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../Users/UserDetail/CommentModal/TargetContainer";
import styled from "styled-components";
import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { authType } from "../../../../pages/Login";
import dayjs from "dayjs";
import Blank from "../../../DefaultStyles/Blank";
import { Input } from "../../../Input/Input";
import { ModalRow } from "../../Users/UserDetail/BlackListModal/BlackListModal";
import { ModalRowContentContainer } from "../../AlimTalk/AlimTalkModal";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import { getSubscriptionNameV3 } from "../../../../ApiTS/ServiceDatasTS_V3";
import { getStateStr } from "../../../../pages/Party/Lingokids";
import { getYTStateString } from "../../../../pages/Party/YoutubeMatchingInfo";
import CalendarModalBtn from "../../../Button/CalendarModalBtn";

interface YoutubeUpdateModalProps extends DefaultModalCommonProps {
  uid: number;
  partyid: number;
  ytstate: number;
  servsubsid: number;
  dueDate?: string;
  confirmEvent: () => void;
  closeEvent: () => void;
  enddate?: string;
}

export default function YoutubeUpdateModal({
  closeEvent,
  confirmEvent,
  partyid,
  ytstate,
  uid,
  servsubsid,
  dueDate,
  enddate,
}: YoutubeUpdateModalProps) {
  const auth = useRecoilValue(authType);
  const [updateBtnClick, setUpdateBtnClick] = useState(false);
  const [savedValues, setSavedValues] = useState({
    partyid: String(partyid),
    ytstate: String(ytstate),
    dueDate: dueDate || "",
  });

  const savedYtstate = Number(savedValues.ytstate);

  const options: OptionType[] = [
    // {
    //   value: "1",
    //   label: getYTStateString(1),
    //   isDisabled: ytstate >2  ? true : false,
    // },
    // 접수중
    {
      value: "2",
      label: getYTStateString(2),
      // 접수중이나 처리완료는 수정 불가능
      isDisabled: savedYtstate === 2 ? true : false,
    },
    // 처리완료
    {
      value: "3",
      label: getYTStateString(3),
      // 접수중이 아니면 불가능
      isDisabled: savedYtstate !== 2 ? true : false,
    },
    // // 계정정보 수정 필요
    // {
    //   value: "4",
    //   label: getYTStateString(4),
    //   // 예정이거나 계정정보 수정 필요면 불가능
    //   isDisabled: ytstate !== 2 ? true : false,
    // },
    // // 백업코드 수정 필요
    // {
    //   value: "5",
    //   label: getYTStateString(5),
    //   // 예정이거나 백업코드 수정필요면 불가능
    //   isDisabled: ytstate !== 2 ? true : false,
    // },
    // 보류 (추후 처리)
    {
      value: "7",
      label: getYTStateString(7),
      // 예정이거나 보류중이면 불가능
      isDisabled: savedYtstate !== 2 ? true : false,
    },
    // 호출 완료
    {
      value: "8",
      label: getYTStateString(8),
      // 예정이거나 보류중이면 불가능
      isDisabled: savedYtstate !== 2 ? true : false,
    },
  ];

  const [dropDownValue, setDropDownValue] = useState<OptionType>({
    value: String(ytstate),
    label: getYTStateString(ytstate),
  });

  interface Party {
    servsubsid: number;
    partyid: string;
    grade: number;
    // add other properties if needed
  }
  const [PartyList, setPartyList] = useState<Party[]>([]);
  const [SelectedParty, setSelectedParty] = useState<OptionType>({
    value: String(partyid) ?? "",
    label: partyid !== 0 ? String(partyid) : "선택",
  });

  const [selectedDueDate, setSelectedDueDate] = useState<string>(dueDate || "");

  // const {
  //   response: partyListResponse,
  //   error: partyListError,
  //   loading: partyListLoading,
  // } = useApi({
  //   method: "get",
  //   url: `party?servsubsid=${servsubsid}&state=1&page=0&size=100`,
  // });

  const isPartyChanged = SelectedParty?.value !== savedValues.partyid;
  const isYtstateChanged = dropDownValue?.value !== savedValues.ytstate;
  const isDueDateChanged = selectedDueDate !== savedValues.dueDate;
  const hasChanges = isPartyChanged || isYtstateChanged || isDueDateChanged;

  const isDueDateRequired =
    dropDownValue?.value === "7" || dropDownValue?.value === "3";

  const handleConfirm = () => {
    if (!hasChanges) {
      return;
    }

    if (isDueDateRequired && !selectedDueDate) {
      toast.error("목표일을 선택하세요");
      return;
    }
    setUpdateBtnClick(true);
  };

  const { response, loading, error } = useApi({
    method: "post",
    url: updateBtnClick ? `proxyparty` : undefined,
    data: {
      uid: uid,
      partyid: Number(SelectedParty?.value),
      ...(isYtstateChanged && { ytstate: Number(dropDownValue?.value) }),
      ...(isDueDateChanged && { duedate: selectedDueDate }),
    },
  });

  useEffect(() => {
    if (response?.status === 200) {
      toast.success("변경하였습니다.");
      setUpdateBtnClick(false);
      setSavedValues({
        partyid: SelectedParty.value ?? "",
        ytstate: dropDownValue.value ?? "",
        dueDate: selectedDueDate,
      });
      confirmEvent();
    }
  }, [response]);

  useEffect(() => {
    if (
      error
      //  || partyListError
    ) {
      toast.error(error?.data ?? "로그 확인에 실패하였습니다.");
      setUpdateBtnClick(false);
    }
  }, [
    error,
    // partyListError
  ]);

  //   파티 리스트 받아오기
  // useEffect(() => {
  //   if (
  //     partyListResponse?.status === 200 ||
  //     partyListResponse?.status === 201
  //   ) {
  //     setPartyList(partyListResponse?.data?.items);
  //     //   toast.success("파티 리스트 받아오기 완료.");
  //   }
  // }, [partyListResponse]);

  console.log(uid, SelectedParty.value, dropDownValue.value);

  return (
    <>
      <DefaultModalLayout
        modalTitle="유튜브 상태 수정"
        closeEvent={() => closeEvent()}
        confirmEvent={handleConfirm}
        isMediumModal={true}
        confirmDisabled={
          !hasChanges ||
          dropDownValue?.label === "선택" ||
          SelectedParty?.label === "선택"
        }
      >
        <ModalRow>
          <ModalLabel>파티 ID</ModalLabel>
          <ModalRowContentContainer>
            {partyid !== 0 ? (
              <ModalFixedBox>{partyid}</ModalFixedBox>
            ) : (
              <DropDown
                dropdownValue={SelectedParty}
                setDropDownValue={setSelectedParty}
                optionList={PartyList.map((party) => ({
                  value: String(party.partyid),
                  label: `${String(party.partyid)}`,
                }))}
                // boxWidth={0}
              />
            )}
          </ModalRowContentContainer>
        </ModalRow>

        <ModalRow>
          <ModalLabel>상태</ModalLabel>

          <ModalRowContentContainer>
            <DropDown
              isDisabled={false}
              setDropDownValue={setDropDownValue}
              dropdownValue={dropDownValue}
              optionList={options}
              // boxWidth={180}
            />
          </ModalRowContentContainer>
        </ModalRow>

        {dropDownValue?.value === "7" || dropDownValue?.value === "3" ? (
          <ModalRow>
            <ModalLabel>목표일</ModalLabel>
            <ModalRowContentContainer>
              <DueDateContainer>
                <CalendarModalBtn
                  calendar={{
                    value: selectedDueDate
                      ? dayjs(selectedDueDate).format("YYYY-MM-DD")
                      : "",
                    initValue: "날짜 선택",
                  }}
                  modal={{
                    dateValue: selectedDueDate,
                    changeEvent: (date: string) => setSelectedDueDate(date),
                    maxDate: enddate,
                  }}
                />
                {dropDownValue?.value === "3" && (
                  <QuickDateButtonContainer>
                    <QuickDateButton
                      onClick={() =>
                        setSelectedDueDate(
                          dayjs().add(3, "month").format("YYYY-MM-DD")
                        )
                      }
                    >
                      3개월 후
                    </QuickDateButton>
                    <QuickDateButton
                      onClick={() => enddate && setSelectedDueDate(enddate)}
                      disabled={!enddate}
                    >
                      종료일까지
                    </QuickDateButton>
                  </QuickDateButtonContainer>
                )}
              </DueDateContainer>
            </ModalRowContentContainer>
          </ModalRow>
        ) : (
          <></>
        )}

        <Blank marginHeight={20} blankHeight={20} />
      </DefaultModalLayout>

      {loading && <Loader />}
    </>
  );
}

const Column = styled.div`
  width: 250px;
`;

const Row = styled.div`
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;
const ValueContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const DueDateContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const QuickDateButtonContainer = styled.div`
  display: flex;
  gap: 8px;
`;

const QuickDateButton = styled.button`
  padding: 6px 12px;
  border: 1px solid #d3d3d3;
  border-radius: 8px;
  background-color: #ffffff;
  font-size: 13px;
  font-weight: 500;
  color: #505050;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f5f5f5;
  }

  &:disabled {
    color: #d3d3d3;
    cursor: not-allowed;

    &:hover {
      background-color: #ffffff;
    }
  }
`;
